// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as LocalStorageConstants$PorterinUtils from "../constants/LocalStorageConstants.mjs";

function isLocalStorageAvailable(param) {
  return (function() {
            let isLocalStorageAvailable = false
            try {
                if (typeof localStorage !== 'undefined') {
                    localStorage.setItem('feature_test', 'yes');
                    if (localStorage.getItem('feature_test') === 'yes') {
                        localStorage.removeItem('feature_test');
                        isLocalStorageAvailable = true
                    } else {
                        isLocalStorageAvailable = false
                    }
                } else {
                    isLocalStorageAvailable = false
                }
            } catch (e) {
                isLocalStorageAvailable = false
            }
            return isLocalStorageAvailable
        }());
}

function updateUserCity(city) {
  if (isLocalStorageAvailable(undefined)) {
    localStorage.setItem(LocalStorageConstants$PorterinUtils.user_city, city.toLocaleLowerCase());
    return ;
  }
  
}

function getUserCity(setCitySelected) {
  if (!isLocalStorageAvailable(undefined)) {
    return ;
  }
  var city = localStorage.getItem(LocalStorageConstants$PorterinUtils.user_city);
  if (!(city == null)) {
    return Curry._1(setCitySelected, city);
  }
  
}

function readPropertyFromLocalStorage(key) {
  var value = localStorage.getItem(key);
  if (value !== null && value !== "") {
    return value;
  }
  
}

export {
  isLocalStorageAvailable ,
  updateUserCity ,
  getUserCity ,
  readPropertyFromLocalStorage ,
}
/* No side effect */
